import type { KYCState } from "./types";
import { resourceSliceFactory } from "infrastructure/store/state";

const state: KYCState = resourceSliceFactory();

export const sliceToken = 'kyc';

export default state;
